var map = {
	"./nerd.svg": 996,
	"./promo3-1.svg": 997,
	"./promo3-2.svg": 998,
	"./promo3-background-desk.svg": 999,
	"./promo3-background-mob.svg": 1000,
	"./promo_1.svg": 1001,
	"./promo_1_mob.svg": 1002,
	"./promo_1_pic_1.svg": 1003,
	"./promo_1_pic_2.svg": 1004,
	"./promo_2.svg": 1005,
	"./promo_2_pic_1.svg": 1006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 995;